<mat-tab-group [selectedIndex]="selected.value" (selectedIndexChange)="onTabChange($event)" mat-stretch-tabs mat-align-tabs="center">
  <mat-tab i18n-label="@@products" label="Products">
    <div>
      <div class="header-style">
        <div>
        </div>
        <div class="d-flex justify-content-center align-items-center">
          <mat-paginator i18n-aria-label="@@paginator" [length]="totalSize" [pageSize]="pageSize" [pageIndex]="pageNumber - 1" [pageSizeOptions]="[10, 20, 50, 100]" (page)="handleProductPage($event)"></mat-paginator>
          
          @if(productsList.length > 0) {
            <mat-menu #exportProductsMenu="matMenu">
              <button mat-menu-item i18n="@@exportCsv" (click)="exportManufacturerProducts(1)">Export as CSV</button>
              <button mat-menu-item i18n="@@exportPdf" (click)="exportManufacturerProducts(2)">Export as PDF</button>
              <button mat-menu-item i18n="@@exportExcel" (click)="exportManufacturerProducts(3)">Export as Excel</button>
            </mat-menu>
            <mat-icon svgIcon="export" class="cursor export-icon" aria-hidden="false" i18n-aria-label="@@export" aria-label="Export" [matMenuTriggerFor]="exportProductsMenu"></mat-icon>
          }
          
          <form [formGroup]="searchForm" (ngSubmit)="doProductSearch()">
            @if (showSearchProduct) {
              <mat-form-field class="search-field">
                <mat-label i18n="@@searchLabel">Search</mat-label>
                <input i18n-placeholder="@@searchPlaceholder" data-testid="products_search_input"  matInput formControlName="productSearch" id="productSearch" placeholder="Search" name="productSearch"/>
                <mat-icon data-testid="products_clear" class="cursor" matSuffix i18n-aria-label="@@clearSearch" aria-label="Clear search" (click)="clearProductSearch()">clear</mat-icon>
              </mat-form-field>
            }
          </form>
          <mat-icon data-testid="products_search" (click)="handleProductSearchClick()" class="cursor" i18n-aria-label="@@search" aria-label="Search" svgIcon="search" aria-hidden="false"></mat-icon>
        </div>
      </div>
      @for (item of productsList; track item; let itemIndex = $index) {
        <mat-card (click)="openProduct(item.isSupeAdminHasAccess, item.id, item.name)" class="{{(itemIndex % 2 === 0 ? 'lite-box mr-16 cursor' : 'lite-box m-0 cursor')}}">
          <mat-card-content class="d-flex">
            <img [src]="item.picture" i18n-alt="@@productImage" alt="Product image" (error)="onImgError($event)">
            <div class="content-box">
              <div class="text-wrapper">
                <div class="mat-subtitle-1 mb-8" matTooltip ellipsisTooltip>{{item.name}}</div>
                <div class="mat-caption" matTooltip ellipsisTooltip>{{truncateDescription(item.description)}}</div>
              </div>
              @if (!item.isSupeAdminHasAccess) {
                <mat-icon class="cursor" color="warn" i18n-aria-label="@@locked" aria-label="Locked">lock</mat-icon>
              }
            </div>
          </mat-card-content>
        </mat-card>
      }
      @if (productsList.length === 0) {
        <img class="empty-view-img" i18n-alt="@@emptyView" alt="No data" src="{{utils.isDarkMode() ? '../../../assets/images/empty-view-dark.svg' : '../../../assets/images/empty-view.svg'}}">
      }
    </div>
  </mat-tab>
  <mat-tab i18n-label="@@sponsors" label="Sponsoring">
    <div>
      <div class="header-style">
        <div>
        </div>
        <div class="d-flex justify-content-center align-items-center">
          <mat-paginator i18n-aria-label="@@paginator" [length]="sponsorsTotalSize" [pageSize]="sponsorPageSize" [pageIndex]="sponsorPageNumber - 1" [pageSizeOptions]="[10, 20, 50, 100]" (page)="handleSponsorsPage($event)"></mat-paginator>
          <mat-icon data-testid="add_promotion_button" (click)="openAddPromotion()" class="cursor add-icon" i18n-aria-label="@@addPromotion" aria-label="Add promotion" svgIcon="add" aria-hidden="false"></mat-icon>
          
          @if(promotionsList.length > 0) {
            <mat-menu #exportSponsorsMenu="matMenu">
              <button mat-menu-item i18n="@@exportCsv" (click)="exportManufacturerSponsoring(1)">Export as CSV</button>
              <button mat-menu-item i18n="@@exportPdf" (click)="exportManufacturerSponsoring(2)">Export as PDF</button>
              <button mat-menu-item i18n="@@exportExcel" (click)="exportManufacturerSponsoring(3)">Export as Excel</button>
            </mat-menu>
            <mat-icon svgIcon="export" class="cursor export-icon" i18n-aria-label="@@export" aria-label="Export" aria-hidden="false" [matMenuTriggerFor]="exportSponsorsMenu"></mat-icon>
          }
          
          <form [formGroup]="searchForm" (ngSubmit)="doSponsorSearch()">
            @if (showSearchSponsor) {
              <mat-form-field class="search-field">
                <mat-label i18n="@@searchLabel">Search</mat-label>
                <input i18n-placeholder="@@searchPlaceholder" data-testid="promotions_search_input" matInput formControlName="sponsorSearch" id="sponsorSearch" placeholder="Search" name="sponsorSearch"/>
                <mat-icon data-testid="promotions_clear_button" class="cursor" matSuffix i18n-aria-label="@@clearSearch" aria-label="Clear search" (click)="clearSponsorSearch()">clear</mat-icon>
              </mat-form-field>
            }
          </form>
          <mat-icon data-testid="promotions_search_button" (click)="handleSponsorSearchClick()" class="cursor" i18n-aria-label="@@search" aria-label="Search" svgIcon="search" aria-hidden="false"></mat-icon>

        </div>
      </div>
      @for (item of promotionsList; track item; let itemIndex = $index) {
        <mat-card class="{{(itemIndex % 2 === 0 ? 'lite-box-without-img mr-16 ' : 'lite-box-without-img')}}">
          <mat-card-content class="content-box">
            <div>
              <div class="mat-subtitle-1 mb-8" matTooltip ellipsisTooltip i18n="@@promoCode">Code - {{item.code}}</div>
              @if (item.isUsed) {
                <div i18n="@@used" class="mat-caption mb-8">Used</div>
              }
              @if (!item.isUsed) {
                <div i18n="@@notUsed"class="mat-caption mb-8">Not Used</div>
              }
              <div class="mat-caption mb-8" matTooltip ellipsisTooltip>{{item.expireDate}}</div>
              <div class="mat-caption mb-8 d-inline">@if (item.isUsed) {
                <span i18n="@@companyUsed" matTooltip ellipsisTooltip>Company Used: {{item.companyName}} </span>
                }@if (!item.isUsed) {
                <span>.</span>
              }</div>
            </div>
            <mat-icon data-testid="promotions_delete_button" class="cursor" color="warn" i18n-aria-label="@@delete" aria-label="Delete" (click)="deletePromotion(item.id, item.code)" aria-hidden="false">delete_outline</mat-icon>
          </mat-card-content>
        </mat-card>
      }
      @if (promotionsList.length === 0) {
        <img class="empty-view-img" i18n-alt="@@emptyView" alt="No data" src="{{utils.isDarkMode() ? '../../../assets/images/empty-view-dark.svg' : '../../../assets/images/empty-view.svg'}}">
      }
    </div>
  </mat-tab>
</mat-tab-group>
